import React from 'react';
import styled from 'styled-components';

const StyledColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: ${({ column }) => (column ? 'column' : 'row')};
  ${({ itemsCenter }) =>
    itemsCenter && `align-items: center;` && `justify-content: center;`}
  height: ${({ height }) => height || 'auto'};
  min-height: ${({ height }) => height || 'auto'};
  padding: ${({ padding }) => padding || '0'};
`;

const Column = ({ children, ...props }) => {
  return <StyledColumn {...props}>{children}</StyledColumn>;
};

export default Column;
